
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"300","height":"110","viewBox":"0 0 79.375 29.104","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.011 11.728l.009 5.489.008 5.489-5.826-2.739-5.826-2.738 5.817-2.75zM41.836 5.592c2.048-.006 4.128.094 5.182.295 3.173.601 6.756 4.828 6.756 4.828.347 0 2.379.137 3.854.24.885.063 1.634.466 1.744 1.247l.603 5.6c0 1.377-.603 1.479-1.072 1.562-.418.08-2.197.216-2.597.246a4.87 4.87 0 00-4.869-5.02 4.873 4.873 0 00-4.878 4.868c0 .055.002.11.004.164l-14.718-.001c.001-.034.005-.068.005-.102a4.87 4.87 0 00-4.872-4.867 4.873 4.873 0 00-4.878 4.867c0 .023.003.045.003.068-.918-.024-1.864-.065-1.952-.13-.3-.218-.815-1.487-.804-1.935.035-1.538.837-3.24 1.863-4.038 1.647-1.28 3.068-1.895 7.947-2.537 0 0 5.269-4.422 7.692-5.014.924-.224 2.94-.336 4.987-.341z"}}),_c('path',{attrs:{"d":"M55.493 19.448a4.064 4.064 0 11-8.125 0 4.06 4.06 0 014.065-4.056 4.059 4.059 0 014.06 4.056zM30.954 19.448a4.064 4.064 0 11-8.126 0 4.06 4.06 0 014.065-4.056 4.059 4.059 0 014.06 4.056z"}})])
          )
        }
      }
    